import { warn } from "@ember/debug";
import ControlTower from "wise-control-tower";

export default function logError(error: Error, id: string) {
  const errMsg = `Detected error "${id}" with description:\n\n${error}`;
  warn(errMsg, { id: id });
  ControlTower.captureMessage(errMsg);
}
